import { render, staticRenderFns } from "./openDialog.vue?vue&type=template&id=2fc77c5a&scoped=true&"
import script from "./openDialog.vue?vue&type=script&lang=ts&"
export * from "./openDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc77c5a",
  null
  
)

export default component.exports